import $ from 'jquery'

var subscribeText = function() {

    function subscribeTextChange() {
        var windowWidth = window.innerWidth;
        
        if (windowWidth < 700 && windowWidth > 480) {
            $('#input_3_1').attr('placeholder', 'Stay Hungry. Enter you email to subscribe');
        } 
        else if(windowWidth < 480) {
            $('#input_3_1').attr('placeholder', 'Newsletter Sign Up');
        }
        else {
            $('#input_3_1').attr('placeholder', 'Stay Hungry. Enter your email to sign up for our newsletter. ');
        }
    }

    subscribeTextChange();

    $(window).on('resize', function() {
        setTimeout(subscribeTextChange, 250 );
    });

}

module.exports = subscribeText;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/footer.js